

















import Vue from "vue";
const isTablet = (window as any).isTablet
export default Vue.extend({
  props: ["height"],
  data() {
    return {
      isTablet,
    }
  }
});
